import { Outlet, useNavigate } from 'react-router-dom'
import LogOut from 'lucide-react/dist/esm/icons/log-out'
import { useAuth } from '@/contexts/AuthContext'
import { BottomNav } from './BottomNav'
import { Button } from '@/components/ui/button'

export function AppLayout() {
  const { logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-40 flex items-center justify-between border-b bg-background px-4 py-3">
        <span className="text-lg font-semibold">Mezza Affiliates</span>
        <Button
          variant="ghost"
          size="icon"
          onClick={handleLogout}
          aria-label="Log out"
          className="text-muted-foreground hover:text-foreground"
        >
          <LogOut className="h-5 w-5" />
        </Button>
      </header>

      <main className="flex-1 pb-20">
        <Outlet />
      </main>

      <BottomNav />
    </div>
  )
}
